import { combineReducers } from 'redux';

import currentAdvertIds, * as fromCurrentAdvertIds from '../../adverts/combinedResults/currentAdvertIds';

import currentFlightItineraryIds, * as fromCurrentFlightItineraryIds from './currentFlightItineraryIds';

import type { CurrentAdvertIdsState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entityCollections/currentAdvertIds';
import type { CurrentFlightItineraryIdsState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entityCollections/currentFlightItineraryIds';
import type { EntityCollectionsState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entityCollections/entityCollections';

export default combineReducers({
  currentFlightItineraryIds,
  currentAdvertIds,
});

export const getCurrentFlightItineraryIds = (
  state: EntityCollectionsState,
): CurrentFlightItineraryIdsState =>
  fromCurrentFlightItineraryIds.getAll(state.currentFlightItineraryIds);
export const getCurrentAdvertIds = (state: EntityCollectionsState): CurrentAdvertIdsState =>
  fromCurrentAdvertIds.getAll(state.currentAdvertIds);
